import { render, staticRenderFns } from "./UrgenciasView.vue?vue&type=template&id=44a1c3f0&scoped=true"
import script from "./UrgenciasView.vue?vue&type=script&lang=js"
export * from "./UrgenciasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1c3f0",
  null
  
)

export default component.exports